<template>
  <div class="quick-search-cta-element">
    <div class="info">
      <div class="nds-text-p-small-bold header">
        <svg-element
          icon="help"
          size="16"
        />
        {{ $t('ask_no_found_company') }}
      </div>
      <div class="nds-text-p-small">
        {{ $t('solution_for_you') }}
      </div>
      <v-tooltip
        v-if="user_has_reached_inquiry_quota"
        location="bottom"
        width="580"
        :text="$t(
          'inquiry_quota_reached_message',
          { count: user_inquiry_quota_count }
        )"
        attach
      >
        <template #activator="{ props }">
          <div
            v-bind="props"
            class="nds-text-link-small cta disabled"
          >
            <svg-element
              icon="arrow-right"
              size="12"
            />
            {{ $t('request_inquiry') }}
          </div>
        </template>
      </v-tooltip>
      <a
        v-else
        href="/reports?open-inquiry-popup=true"
      >
        <div class="nds-text-link-small cta">
          <svg-element
            icon="arrow-right"
            size="12"
          />
          {{ $t('request_inquiry') }}
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import SvgElement from '@/components/elements/SvgElement.vue';
export default {
  name: 'QuickSearchCtaElement',
  components: {
    SvgElement,
  },
  computed: {
    ...mapGetters({
      user_data: 'user/userData',
      user_has_reached_inquiry_quota: 'inquiry/userHasReachedInquiryQuota',
      user_inquiry_quota_count: 'inquiry/inquiryQuotaCount',
    }),
  },
  async mounted() {
    await this.checkIfUserHasReachedInquiryQuota({ user_id: this.user_data.id });
  },
  methods: {
    ...mapActions({
      checkIfUserHasReachedInquiryQuota: 'inquiry/checkIfUserHasReachedInquiryQuota',
    }),
  },
};
</script>

<style lang="scss" scoped>
@import '@/constants/variables.module.scss';

.quick-search-cta-element {
  div {
    color: $cornflower-blue;
  }
  a {
    text-decoration: none;
  }

  .info {
    padding: 16px;
    border-radius: 20px;
    background-color: $zumthor;
    margin: 16px 0;

    .header {
      display: flex;
      align-items: center;
      gap: 6px;
      svg {
        --color: #{$cornflower-blue};
      }
    }
  }
  .cta {
    margin-top:16px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: flex-end;
    svg {
      --color: #{$cornflower-blue};
    }
    &.disabled {
      color: $amethyst-smoke;
      cursor: not-allowed;
      svg {
        --color: #{$amethyst-smoke};
      }
    }
  }
}
</style>

<i18n src="@/locales/common.json"></i18n>

<i18n src="@/locales/components/elements/quick_search/quick-search-cta-element.json"></i18n>
